import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
import { Clipboard } from '@ionic-native/clipboard';

import { TabsPage } from '../tabs/tabs';
import { LoginPage } from '../login/login';
import { CreatemodalPage } from '../createmodal/createmodal';

/**
 * Generated class for the CreatewallPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-createwall',
  templateUrl: 'createwall.html',
})
export class CreatewallPage {
  
	email : string;
	wallet_address: string;
	security: string;
	loginId: string;
	api_key: string;
	version: string;
	servermode: string;
	main_qr_url: string;
	test_qr_url: string;
	company: string;
	img_loaded_count: number = 0;

	is_enabled_btn_download: boolean = true;
	img_qr_wallet = new Image();
	img_qr_key = new Image();
    gr_save:boolean = false;

	texts: any = [];
    language : string;

    win: any;
    Confirm: any;
                    

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		private alertCtrl: AlertController,
		public modalCtrl: ModalController,
        private clipboard: Clipboard,
		// public photoLibrary: PhotoLibrary,
		public app: App
	) {		
		// this.photoLibrary.requestAuthorization({read: true,write: true});
	}

    ionViewWillEnter() {
		//// 로그인 정보
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}
		
		//// 페이지 이름
		localStorage.setItem("pageName", "createwall");
		this.company = localStorage.getItem("company");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.servermode = localStorage.getItem("servermode");
        this.main_qr_url = localStorage.getItem("main_qr_url");
        this.test_qr_url = localStorage.getItem("test_qr_url");

		this._get_texts();
		this.modalCtrl.create(CreatemodalPage).present();
		this._init();
	
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).createwall;
	}

    // _qr_create() {
    //     this.is_enabled_btn_download = false;
    //     let body = JSON.stringify({ 
	// 		api: this.api_key,
    //         language: this.language,
    //         version: this.version
	// 	});
	// 	this.http.post("union/security", body).then((res:any)=>{
	// 		if(res.result == "OK") {
    //             if (this.servermode == "Y") {
    //                 this.win = window.open(this.main_qr_url + this.loginId, '_top');
    //             } else {
    //                 this.win = window.open(this.test_qr_url + this.loginId, '_top');
    //             }
    //             this.Confirm = setInterval(() => {this.timer();}, 10000);

	// 		} else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
    //             alert.present();
    //             this.is_enabled_btn_download = true;
	// 			localStorage.removeItem("loginId");
	// 			localStorage.removeItem("api_key");
	// 			this.app.getRootNav().setRoot(LoginPage);
			
	// 		} else {
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
    //             alert.present();
    //             this.is_enabled_btn_download = true;
	// 		}
	// 	},(err)=>{
	// 		let alert = this.alertCtrl.create({
	// 			message: this.texts.alertM_err,
	// 			buttons: ['OK']
	// 		});
    //         alert.present();
    //         this.is_enabled_btn_download = true;
	// 	});
    // }

    // timer() {
    //     let body = JSON.stringify({
	// 		api: this.api_key,
    //         language: this.language,
    //         version: this.version
	// 	});
    //     this.http.post("union/security/index/check", body).then((res:any)=>{
    //         if(res.result == "OK") {
    //             clearInterval(this.Confirm);
    //             this.win.close();
    //             // this.
    //             let alert = this.alertCtrl.create({
    //                 message: this.texts.alertM_sucess,
    //                 buttons: [
    //                     {
    //                         text: this.texts.ok_btn,
    //                         handler: () => {
    //                             this.navCtrl.setRoot(TabsPage);
    //                             this.is_enabled_btn_download = true;
    //                         }
    //                     }
    //                 ]
    //             });
    //             alert.present();
    //         }
    //     },(err)=>{
    //         let alert = this.alertCtrl.create({
    //             message: this.texts.alertM_err,
    //             buttons: ['OK']
    //         });
    //         alert.present();
    //         this.is_enabled_btn_download = true;
    //     });
    // }

	_init() {
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post("user/security/index/create", body).then((res:any)=>{
			if(res.result == "OK") {
				// this.wallet_address = res.wallet_address;
                this.security = res.security;

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

    _confirm() {
        let alert = this.alertCtrl.create({
			message: this.texts.alertM_confirm,
			buttons: [
				{
					text: "No"
				},
				{
					text: "Yes",
					handler: () => {
                        this.navCtrl.setRoot(TabsPage);
					}
				}
			]
		});
		alert.present();
    }

    _copy_security(security) {

        if (!this.is_enabled_btn_download) {
            this.clipboard.copy(security);
            let alert = this.alertCtrl.create({
                title: this.texts.alertM_copy_title,
                message: security + this.texts.alertM_copy_message, 
                buttons: ['OK']
            });
            alert.present();
            this.is_enabled_btn_download = false;

        } else if (this.is_enabled_btn_download) {
            let body = JSON.stringify({ 
                api: this.api_key,
                language: this.language,
                version: this.version
            });
            this.http.post("union/security", body).then((res:any)=>{
                if(res.result == "OK") {
                    this.clipboard.copy(security);
                    let alert = this.alertCtrl.create({
                        title: this.texts.alertM_copy_title,
                        message: security + this.texts.alertM_copy_message, 
                        buttons: ['OK']
                    });
                    alert.present();
                    this.is_enabled_btn_download = false;

                } else if(res.result ==="LOGOUT"){
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    this.is_enabled_btn_download = true;
                    localStorage.removeItem("loginId");
                    localStorage.removeItem("api_key");
                    this.app.getRootNav().setRoot(LoginPage);
                
                } else {
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    this.is_enabled_btn_download = true;
                }
            },(err)=>{
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_err,
                    buttons: ['OK']
                });
                alert.present();
                this.is_enabled_btn_download = true;
            });
        }
        
	}

    _close() {
        this.app.getRootNav().setRoot(LoginPage);
    }
}


// WEBPACK FOOTER //
// ./src/pages/createwall/createwall.ts